import HeaderDataActiveMenuContextProvider from './Header/HeaderMenuActiveDataContext';
import HeaderLayout from './HeaderLayout';
import HeaderMenuContextProvider from './Header/HeaderMenuContext';

const HeaderContainer = () => (
  <HeaderMenuContextProvider>
    <HeaderDataActiveMenuContextProvider>
      <HeaderLayout />
    </HeaderDataActiveMenuContextProvider>
  </HeaderMenuContextProvider>
);

export default HeaderContainer;
